/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcMfrecoV1PositionDayEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_MFRECO_V1_POSITION_DAY_EVENT_ENTITY_NAME = 'ixc.mfreco.v1.PositionDayEvent';
export const ixcMfrecoV1PositionDayEventEntity = new schema.Entity<IxcMfrecoV1PositionDayEvent>(IXC_MFRECO_V1_POSITION_DAY_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcMfrecoV1PositionDayEvent) => `${entity.metadata?.eventId}` });

